import { unstableBaseToast } from '@spotnana/blocks/src/Toast';

/**
 * @deprecated
 * DO NOT USE THIS. WILL BE REMOVED IN FUTURE
 * Use blocks toast
 */
export const toast = unstableBaseToast;
